import React, { useEffect } from "react";
import "./LegendBox.css";
import { useView } from "src/contexts/ViewContext";
import { useConfiguration } from "src/contexts/ConfigurationContext";
import { calculateHeight, fromMmToUnit } from "src/helpers/dimensions";
import { calculateKapschuurBigHeight } from "src/helpers/configuration";

const LegendBox: React.FC = () => {
  const { isOptionVisible } = useView();
  const { state } = useConfiguration();
  const [customText, setCustomText] = React.useState("");

  useEffect(() => {
    const customBlockElement = document.getElementById(
      "configurator-custom-block"
    );

    if (customBlockElement) {
      setCustomText(customBlockElement.innerHTML);
    }
  }, []);
  return <></>;
  return (
    <div className={"legend-box"}>
      <div className={`OptionBox ${isOptionVisible ? "" : "hidden"}`}>
        <div className="optionsBoxBlock">
          <div className="optionsBoxHeader">Dimensions</div>
          <div className="optionBoxBullets">
            <div className="optionBoxBullet"></div>
            <div className="optionBoxBullet"></div>
          </div>

          <div className="optionsBoxTitle">Width</div>
          <div className="optionsBoxValue">
            {fromMmToUnit(state.dimensions.width, "cm")}
          </div>

          <div className="optionsBoxTitle">Depth</div>
          <div className="optionsBoxValue">
            {fromMmToUnit(state.dimensions.depth, "cm")}
          </div>
        </div>

        <div className="optionBoxSeparator"></div>
        {/* 
        <div className="optionsBoxBlock">
          <div className="optionsBoxHeader">Fundering</div>
          <div className="optionBoxBullets">
            <div className="optionBoxBullet"></div>
            <div className="optionBoxBullet"></div>
          </div>

          <div className="optionsBoxTitle">Breedte</div>
          <div className="optionsBoxValue">
            {fromMmToUnit(state.dimensions.width, "cm")}
          </div>

          <div className="optionsBoxTitle">Diepte</div>
          <div className="optionsBoxValue">
            {fromMmToUnit(state.dimensions.depth, "cm")}
          </div>
        </div> */}

        {/* <div className="optionBoxSeparator"></div> */}
        {/* 
        <div className="optionsBoxBlock">
          <div className="optionsBoxHeader">Bergin</div>
          <div className="optionBoxBullets">
            <div className="optionBoxBullet"></div>
            <div className="optionBoxBullet"></div>
          </div>

          <div className="optionsBoxTitle">Linker</div>
          <div className="optionsBoxValue">
            {fromMmToUnit(
              state.storages.left ? state.dimensions.leftStorageWidth : 0,
              "cm"
            )}
          </div>

          <div className="optionsBoxTitle">Rechter</div>
          <div className="optionsBoxValue">
            {fromMmToUnit(
              state.storages.right ? state.dimensions.rightStorageWidth : 0,
              "cm"
            )}
          </div>
        </div>

        <div className="optionBoxSeparator"></div> */}

        <div className="optionsBoxBlock">
          <div className="optionsBoxHeader">Dakafmetingen</div>
          <div className="optionBoxBullets">
            <div className="optionBoxBullet"></div>
            <div className="optionBoxBullet"></div>
          </div>

          <div className="optionsBoxTitle">Angle of Rotation</div>
          <div className="optionsBoxValue">
            {state.roofType === "oase" ? state.dimensions.angle : 0}deg
          </div>

          <div className="optionsBoxTitle">Nokhoogte</div>
          <div className="optionsBoxValue">
            {state.roofType === "platdak"
              ? fromMmToUnit(state.dimensions.height, "cm")
              : Math.trunc(
                  fromMmToUnit(
                    state.roofType === "aludra"
                      ? state.dimensions.height + 200
                      : state.dimensions.height +
                          (Math.tan((8 * Math.PI) / 180) *
                            (state.dimensions.depth - 110) +
                            0.17 * 1000),
                    "cm"
                  )
                )}
          </div>
        </div>
      </div>

      {customText && (
        <div
          className={`custom-block`}
          dangerouslySetInnerHTML={{ __html: customText }}
        ></div>
      )}
    </div>
  );
};

export default LegendBox;
